import { render } from "./student-billing-address-modal.vue?vue&type=template&id=a7924f5e"
import script from "./student-billing-address-modal.vue?vue&type=script&lang=js"
export * from "./student-billing-address-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__